/* assets/yotpo-stars.js */
/* Changelog:
   - Single refresh pipeline (keine doppelten Funktionen)
   - Debounce + Throttle
   - MutationObserver nur auf direct childList des Grids (subtree:false)
   - Ignoriert Yotpo-eigene Mutationen
   - Sanfter fetch/XHR-Hook, History-Hook
*/

(function () {
  // ===== CONFIG =====
  var DEBOUNCE_MS = 200;   // entkoppelt schnelle Folgeevents
  var THROTTLE_MS = 800;   // harte Obergrenze: max. 1 Refresh pro 800ms

  // ===== STATE =====
  var lastRun = 0;
  var running = false;
  var gridObserver = null;
  var historyPatched = false;
  var fetchPatched = false;
  var xhrPatched = false;

  // ===== UTILS =====
  function now() { return Date.now ? Date.now() : new Date().getTime(); }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function onceReadyYotpo(cb, attempts) {
    attempts = attempts || 0;
    var ready = (window.yotpo && typeof window.yotpo.refreshWidgets === 'function')
             || (window.Yotpo && window.yotpo);
    if (ready) return cb();
    if (attempts > 120) return; // ~12s
    requestAnimationFrame(function () { onceReadyYotpo(cb, attempts + 1); });
  }

  function getGridContainer() {
    // Passe hier ggf. deinen Grid-Selektor an (der erste Treffer wird genutzt)
    return document.querySelector('#ProductGridContainer, #CollectionProductGrid, #product-grid, .product-grid, [data-product-grid]');
  }

  function hasAnyBottomLines(scope) {
    scope = scope || document;
    return !!scope.querySelector('.yotpo.bottomLine');
  }

  // ===== CORE REFRESH =====
  function doRefresh() {
    // Throttle-Hardcap
    var t = now();
    if (t - lastRun < THROTTLE_MS || running) return;
    if (!hasAnyBottomLines(document)) return; // nichts zu tun

    running = true;
    onceReadyYotpo(function () {
      try {
        if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
          window.yotpo.refreshWidgets();
        } else if (window.Yotpo && window.yotpo) {
          new window.Yotpo.API(window.yotpo).refreshWidgets();
        }
      } catch (e) {
        // Fail silent
      } finally {
        lastRun = now();
        running = false;
      }
    });
  }

  var debouncedRefresh = debounce(doRefresh, DEBOUNCE_MS);

  // ===== OBSERVERS & EVENTS =====
  function observeGrid() {
    var grid = getGridContainer();
    if (!grid || !('MutationObserver' in window)) return;

    if (gridObserver) {
      try { gridObserver.disconnect(); } catch (e) {}
      gridObserver = null;
    }

    gridObserver = new MutationObserver(function (mutations) {
      // Ignoriere reine Yotpo-Änderungen, um Feedback-Schleifen zu vermeiden
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        // Nur auf direkte Kinder achten; subtree:false s.u.
        if (m.addedNodes && m.addedNodes.length) {
          var skip = false;
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (!n || n.nodeType !== 1) continue;
            if (n.classList && (n.classList.contains('yotpo') || n.classList.contains('yotpo-small-box') || n.classList.contains('yotpo-bottomline'))) {
              skip = true;
              break;
            }
            // Wenn Yotpo in einer Tiefe appended, könnten die Klassen tiefer liegen
            if (n.querySelector && n.querySelector('.yotpo, .yotpo-small-box, .yotpo-bottomline')) {
              skip = true;
              break;
            }
          }
          if (skip) continue;
          // echte Grid-Änderung → refresh
          debouncedRefresh();
          return;
        }
        if (m.removedNodes && m.removedNodes.length) {
          debouncedRefresh();
          return;
        }
      }
    });

    // WICHTIG: subtree:false, damit Yotpo-Render innerhalb der Cards NICHT erneut triggert
    gridObserver.observe(grid, { childList: true, subtree: false });
  }

  function bindEvents() {
    // Initial
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        observeGrid();
        debouncedRefresh();
      });
    } else {
      observeGrid();
      debouncedRefresh();
    }

    // Theme-/Shopify-Events rund um Facets & Sections
    [
      'facets:updated',
      'facet:changed',
      'collection:updated',
      'shopify:section:load',
      'shopify:section:select',
      'shopify:section:deselect',
      'shopify:section:reorder',
      'shopify:section:unload'
    ].forEach(function (evt) {
      document.addEventListener(evt, function () {
        // Grid könnte ersetzt worden sein → neu attachen
        observeGrid();
        debouncedRefresh();
      });
    });

    // Popstate (Browser vor/zurück bei Filter/Sortierung)
    window.addEventListener('popstate', function () {
      observeGrid();
      debouncedRefresh();
    });

    // History patchen (einmalig)
    if (!historyPatched) {
      historyPatched = true;
      var _pushState = history.pushState;
      var _replaceState = history.replaceState;
      function emit() { observeGrid(); debouncedRefresh(); }
      history.pushState = function () { var r = _pushState.apply(this, arguments); emit(); return r; };
      history.replaceState = function () { var r = _replaceState.apply(this, arguments); emit(); return r; };
    }

    // Sanfter fetch-Patch (einmalig)
    if (!fetchPatched && window.fetch) {
      fetchPatched = true;
      var _fetch = window.fetch;
      window.fetch = function () {
        return _fetch.apply(this, arguments).then(function (res) {
          try {
            // Nur 1x pro Zyklus anstoßen (Debounce/Throttle regelt den Rest)
            setTimeout(function () { observeGrid(); debouncedRefresh(); }, 120);
          } catch (e) {}
          return res;
        });
      };
    }

    // Sanfter XHR-Patch (einmalig)
    if (!xhrPatched && window.XMLHttpRequest) {
      xhrPatched = true;
      var _open = XMLHttpRequest.prototype.open;
      var _send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function () {
        try {
          this.addEventListener('load', function () {
            setTimeout(function () { observeGrid(); debouncedRefresh(); }, 120);
          });
        } catch (e) {}
        return _open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        return _send.apply(this, arguments);
      };
    }
  }

  bindEvents();
})();
